// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.8_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.8_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * multi-agent design tokens — Kimi prose × Sim.ai surfaces.
 *
 * Scoped to .ma-route. Strict rules:
 *   - 4 type sizes: hero / h1 / body / micro
 *   - 1 accent (existing primary)
 *   - 4 state colors (ok / warn / err / busy) — actual state only
 *   - 1 ease, 2 durations (150ms hover, 240ms entrance)
 *   - 3 depth tiers: shadow-sm / shadow-md / shadow-lg
 *   - 2 surface gradients (surface / elevated)
 */

.ma-route {
  /* ── Type ──────────────────────────────────────────────────── */
  --ma-fs-hero:  28px;
  --ma-fs-h1:    18px;
  --ma-fs-body:  15px;
  --ma-fs-micro: 11px;

  --ma-leading-body:  1.65;
  --ma-leading-micro: 1.35;
  --ma-tracking-micro: 0.08em;

  /* ── Color ─────────────────────────────────────────────────── */
  --ma-bg:           hsl(var(--background));
  --ma-surface:      hsl(var(--card));
  --ma-surface-soft: hsl(var(--muted) / 0.4);
  --ma-border:       hsl(var(--border));
  --ma-text:         hsl(var(--foreground));
  --ma-text-muted:   hsl(var(--muted-foreground));
  --ma-accent:       hsl(var(--primary));
  --ma-accent-soft:  hsl(var(--primary) / 0.08);

  --ma-state-ok:    hsl(151 55% 41%);
  --ma-state-warn:  hsl(38 92% 50%);
  --ma-state-err:   hsl(0 72% 51%);
  --ma-state-busy:  hsl(var(--accent-glow, var(--primary)));

  /* ── Geometry ──────────────────────────────────────────────── */
  --ma-radius-sm: 6px;
  --ma-radius-md: 12px;
  --ma-radius-lg: 18px;

  /* ── Depth ─────────────────────────────────────────────────── */
  /* Use --foreground as the shadow base so it adapts: dark in light
     mode (subtle slate shadow on white) and dark in dark mode (deeper
     drop on near-black). The hardcoded 220/2% looked grimy in light. */
  --ma-shadow-rgb: hsl(var(--foreground) / 0.12);
  --ma-shadow-rgb-soft: hsl(var(--foreground) / 0.06);
  --ma-shadow-sm:
    0 1px 2px var(--ma-shadow-rgb-soft),
    0 0 0 1px hsl(var(--border) / 0.7);
  --ma-shadow-md:
    0 4px 6px -1px var(--ma-shadow-rgb-soft),
    0 2px 4px -2px var(--ma-shadow-rgb-soft),
    0 0 0 1px hsl(var(--border) / 0.8);
  --ma-shadow-lg:
    0 18px 28px -10px var(--ma-shadow-rgb),
    0 6px 10px -4px var(--ma-shadow-rgb-soft),
    0 0 0 1px hsl(var(--border) / 0.85);

  /* Surface gradients — use the global card token so they invert. The
     elevated tint is tied to --primary; in light mode the small primary
     blend reads as a faint warm card edge instead of muddy gray. */
  --ma-grad-surface: linear-gradient(
    180deg,
    hsl(var(--card)) 0%,
    color-mix(in oklab, hsl(var(--card)) 92%, hsl(var(--foreground)) 8%) 100%
  );
  --ma-grad-elevated: linear-gradient(
    180deg,
    color-mix(in oklab, hsl(var(--card)) 96%, hsl(var(--primary)) 4%) 0%,
    hsl(var(--card)) 100%
  );
  --ma-grad-accent: linear-gradient(
    135deg,
    hsl(var(--primary) / 0.16) 0%,
    hsl(var(--primary) / 0.04) 100%
  );

  /* ── Motion ────────────────────────────────────────────────── */
  --ma-motion: 150ms;
  --ma-motion-lg: 240ms;
  --ma-ease: cubic-bezier(0.25, 0.46, 0.45, 0.94);

  /* ── Layout ────────────────────────────────────────────────── */
  --ma-rail-w:    0px;             /* no left rail anymore */
  --ma-side-w:   clamp(280px, 24vw, 320px);
  --ma-prose-max: min(1120px, calc(100vw - var(--ma-side-w) - 96px));
  --ma-app-bg: color-mix(in oklab, hsl(var(--background)) 93%, hsl(var(--foreground)) 7%);
  --ma-panel-bg: color-mix(in oklab, hsl(var(--card)) 94%, hsl(var(--background)) 6%);
  --ma-panel-bg-soft: color-mix(in oklab, hsl(var(--card)) 86%, hsl(var(--background)) 14%);
  --ma-divider: color-mix(in oklab, hsl(var(--border)) 58%, transparent);
}

/* Default type on the route */
.ma-route {
  font-size: var(--ma-fs-body);
  line-height: var(--ma-leading-body);
  color: var(--ma-text);
  background:
    radial-gradient(circle at 48% -10%, hsl(var(--primary) / 0.08), transparent 34%),
    var(--ma-app-bg);
}

/* ── Product shell polish ───────────────────────────────────── */
.ma-route .ma-route-header {
  min-height: 48px;
  border-bottom: 1px solid var(--ma-divider);
  background:
    linear-gradient(180deg, color-mix(in oklab, var(--ma-panel-bg) 96%, hsl(var(--foreground)) 4%), var(--ma-panel-bg));
}

.ma-route .ma-ide-shell {
  flex-direction: column;
  background: var(--ma-app-bg);
}

.ma-route .ma-ide-body {
  margin: 0;
  border: 0;
  border-radius: 0;
  background: color-mix(in oklab, hsl(var(--background)) 96%, hsl(var(--foreground)) 4%);
}

/* The shared metadata section caps its file list at max-h-64 (256px). In the
   multi-agent sidebar the list should fill the available column height instead,
   so the surrounding flex-1 section scrolls. Scoped to the left panel only —
   the dev-agent default is untouched. */
.ma-route .ma-left-utility .max-h-64 {
  max-height: none;
}

.ma-route .ma-left-utility,
.ma-route .ma-right-context {
  border-color: var(--ma-divider);
  background:
    linear-gradient(180deg, color-mix(in oklab, var(--ma-panel-bg) 98%, hsl(var(--foreground)) 2%), var(--ma-panel-bg));
}

.ma-route .ma-left-utility {
  border-right: 1px solid color-mix(in oklab, var(--ma-divider) 66%, transparent);
}

.ma-route .ma-right-context {
  border-left: 1px solid color-mix(in oklab, var(--ma-divider) 66%, transparent);
}

.ma-route .ma-center-workspace {
  background:
    linear-gradient(180deg, color-mix(in oklab, hsl(var(--background)) 99%, hsl(var(--foreground)) 1%), hsl(var(--background)));
}

.ma-route .ma-panel-toolbar {
  min-height: 34px;
  border-bottom: 1px solid color-mix(in oklab, var(--ma-divider) 46%, transparent);
  background: color-mix(in oklab, var(--ma-panel-bg) 86%, transparent);
}

.ma-route .ma-panel-section {
  border-bottom: 1px solid color-mix(in oklab, var(--ma-divider) 44%, transparent);
}

.ma-route .ma-panel-section:last-child {
  border-bottom: 0;
}

.ma-route .ma-right-context__scroll {
  padding-bottom: 12px;
  background: var(--ma-panel-bg);
}

.ma-route .ma-right-context__section {
  border-bottom: 1px solid color-mix(in oklab, var(--ma-divider) 44%, transparent);
}

.ma-route .ma-left-utility .border-b,
.ma-route .ma-right-context .border-b,
.ma-route .ma-left-utility [class*="border-b"],
.ma-route .ma-right-context [class*="border-b"] {
  border-bottom-color: color-mix(in oklab, var(--ma-divider) 42%, transparent) !important;
}

.ma-route .ma-left-utility input,
.ma-route .ma-left-utility button,
.ma-route .ma-left-utility [role="combobox"] {
  border-color: color-mix(in oklab, var(--ma-divider) 58%, transparent);
}

/* Floating composer — no dock bar (no border, no fill). The rounded
   .ma-composer-shell floats over the chat; a soft bottom fade keeps scrolling
   text from butting hard against it. The dock catches no pointer events except
   on the shell itself. */
.ma-route .ma-composer-dock {
  border-top: 0;
  background: linear-gradient(180deg, transparent, color-mix(in oklab, var(--ma-app-bg) 70%, transparent));
  pointer-events: none;
}
.ma-route .ma-composer-dock > * {
  pointer-events: auto;
}

.ma-route .ma-composer-shell {
  background: color-mix(in oklab, hsl(var(--background)) 88%, hsl(var(--card)) 12%);
  box-shadow:
    0 12px 28px -24px hsl(var(--foreground) / 0.35),
    inset 0 1px 0 hsl(var(--foreground) / 0.03);
}

/* ── Always visible run strip ───────────────────────────────── */
.ma-route .ma-run-strip {
  display: flex;
  min-height: 48px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 8px 18px;
  border-bottom: 1px solid var(--ma-divider);
  background:
    linear-gradient(180deg, color-mix(in oklab, var(--ma-panel-bg) 94%, hsl(var(--foreground)) 6%), var(--ma-panel-bg));
}

.ma-route .ma-run-strip__stages {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 8px;
}

.ma-route .ma-run-stage {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  border-radius: 999px;
  border: 1px solid transparent;
  padding: 5px 10px;
  color: var(--ma-text-muted);
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
}

.ma-route .ma-run-stage--done {
  border-color: color-mix(in oklab, var(--ma-state-ok) 32%, transparent);
  background: color-mix(in oklab, var(--ma-state-ok) 12%, transparent);
  color: color-mix(in oklab, var(--ma-state-ok) 78%, white 22%);
}

.ma-route .ma-run-stage--active {
  border-color: hsl(var(--primary) / 0.45);
  background: hsl(var(--primary) / 0.11);
  color: hsl(var(--primary));
}

.ma-route .ma-run-stage--warn {
  border-color: color-mix(in oklab, var(--ma-state-warn) 38%, transparent);
  background: color-mix(in oklab, var(--ma-state-warn) 14%, transparent);
  color: color-mix(in oklab, var(--ma-state-warn) 78%, white 22%);
}

.ma-route .ma-run-strip__summary {
  min-width: 180px;
  max-width: min(42vw, 560px);
  overflow: hidden;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--ma-text);
  font-size: 12px;
  font-weight: 600;
}

.ma-route .ma-run-strip__latest {
  color: var(--ma-text-muted);
  font-weight: 500;
}

@media (max-width: 1100px) {
  .ma-route .ma-run-strip {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }

  .ma-route .ma-run-strip__stages {
    flex-wrap: wrap;
  }

  .ma-route .ma-run-strip__summary {
    max-width: 100%;
    text-align: left;
  }
}

/* ── Type utilities ─────────────────────────────────────────── */
.ma-route .ma-hero {
  font-size: var(--ma-fs-hero);
  font-weight: 600;
  letter-spacing: -0.018em;
  line-height: 1.2;
}
.ma-route .ma-micro {
  font-size: var(--ma-fs-micro);
  font-weight: 500;
  letter-spacing: var(--ma-tracking-micro);
  line-height: var(--ma-leading-micro);
  text-transform: uppercase;
  color: var(--ma-text-muted);
}

/* ── Surface (gradient + shadow card) ───────────────────────── */
.ma-route .ma-surface {
  background: var(--ma-grad-surface);
  border-radius: var(--ma-radius-md);
  box-shadow: var(--ma-shadow-sm);
}
.ma-route .ma-surface--soft {
  background: var(--ma-surface-soft);
  box-shadow: none;
}
.ma-route .ma-surface--accent {
  background: var(--ma-grad-accent);
  box-shadow: var(--ma-shadow-sm),
              inset 0 0 0 1px hsl(var(--primary) / 0.25);
}
.ma-route .ma-surface--elevated {
  background: var(--ma-grad-elevated);
  box-shadow: var(--ma-shadow-md);
}

/* ── Interactive (lift + ring) ──────────────────────────────── */
.ma-route .ma-interactive {
  transition:
    box-shadow      var(--ma-motion) var(--ma-ease),
    transform       var(--ma-motion) var(--ma-ease),
    background-color var(--ma-motion) var(--ma-ease);
}
.ma-route .ma-interactive:hover {
  box-shadow: var(--ma-shadow-md);
}
.ma-route .ma-interactive--card:hover {
  transform: translateY(-1px);
}
.ma-route .ma-interactive:focus-visible {
  outline: 2px solid var(--ma-accent);
  outline-offset: 2px;
}

/* ── Status dot ─────────────────────────────────────────────── */
.ma-route .ma-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: var(--ma-text-muted);
  flex: none;
}
.ma-route .ma-dot--ok   { background: var(--ma-state-ok); }
.ma-route .ma-dot--warn { background: var(--ma-state-warn); }
.ma-route .ma-dot--err  { background: var(--ma-state-err); }
.ma-route .ma-dot--busy {
  background: var(--ma-state-busy);
  animation: ma-pulse 1.4s infinite ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .ma-route .ma-dot--busy { animation: none; }
}
@keyframes ma-pulse {
  0%, 100% { opacity: 1; }
  50%      { opacity: 0.35; }
}

/* ── Prose (Kimi answer area) ───────────────────────────────── */
.ma-route .ma-prose {
  max-width: var(--ma-prose-max);
  /* min-width:0 lets this block shrink below its content width inside a
     flex column — without it, flex items can report a wider offsetWidth to
     Monaco than the visual layout, causing the diff editor to overshoot
     into the sidebar. width:100% fills the available column. */
  width: 100%;
  min-width: 0;
  margin: 0 auto;
  padding: 32px 24px 56px;
  font-size: var(--ma-fs-body);
  line-height: var(--ma-leading-body);
  color: var(--ma-text);
}

.ma-route .ma-prose--active-chat {
  /* Fill the full width of the chat column (the centre workspace sets
     --ma-prose-max to 100% in the default layout; narrow/wide variants still
     cap it). Was hard-capped at min(1320px, …) which left dead space on wide
     screens. */
  max-width: var(--ma-prose-max);
  padding-left: clamp(24px, 3vw, 48px);
  padding-right: clamp(24px, 3vw, 48px);
}

.ma-route .ma-prose--active-chat .ma-hero {
  font-size: clamp(26px, 3vw, 40px);
  line-height: 1.16;
}
.ma-route .ma-prose > * + * { margin-top: 18px; }
.ma-route .ma-prose h1,
.ma-route .ma-prose h2,
.ma-route .ma-prose h3 {
  margin-top: 36px;
  font-weight: 600;
  letter-spacing: -0.012em;
  color: var(--ma-text);
}
.ma-route .ma-prose h1 { font-size: 22px; line-height: 1.3; }
.ma-route .ma-prose h2 { font-size: 19px; line-height: 1.35; }
.ma-route .ma-prose h3 {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: var(--ma-tracking-micro);
  color: var(--ma-text);
  font-weight: 600;
}
.ma-route .ma-prose p  { margin: 0; }
.ma-route .ma-prose ul,
.ma-route .ma-prose ol { padding-left: 22px; }
.ma-route .ma-prose li + li { margin-top: 6px; }

/* Real links across the chat — blue + underlined so they read as clickable
   (they used to inherit the muted prose color and looked like plain text). */
.ma-route .ma-link {
  color: #4f9dff;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}
.ma-route .ma-link:hover { color: #74b2ff; }

/* A list that is only citation chips — e.g. the model's "Evidence Artifacts"
   section — flows inline like the Sources strip: wrapped pills, no bullets,
   no vertical stacking. */
.ma-route .ma-prose ul:has(.ma-citation-chip),
.ma-route .ma-prose ol:has(.ma-citation-chip) {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding-left: 0;
  margin-top: 10px;
  list-style: none;
}
.ma-route .ma-prose ul:has(.ma-citation-chip) > li,
.ma-route .ma-prose ol:has(.ma-citation-chip) > li {
  margin: 0;
  list-style: none;
}
.ma-route .ma-prose ul:has(.ma-citation-chip) > li::marker,
.ma-route .ma-prose ol:has(.ma-citation-chip) > li::marker {
  content: "";
}
.ma-route .ma-prose ul:has(.ma-citation-chip) .ma-citation-chip {
  margin-left: 0;
}

/* Expanded artifact blocks break out of list-item flow */
.ma-route .ma-prose .ma-artifact-block,
.ma-route .ma-artifact-block {
  display: block;
  width: 100%;
  margin-top: 8px;
  margin-bottom: 8px;
  list-style: none;
}
.ma-route .ma-prose li:has(.ma-artifact-block) {
  list-style: none;
  margin-left: -22px;
  padding-left: 0;
}

.ma-route .ma-prose code {
  font-size: 13px;
  padding: 2px 6px;
  border-radius: 5px;
  background: var(--ma-surface-soft);
  border: 1px solid hsl(var(--border) / 0.4);
}
.ma-route .ma-prose table {
  width: 100%;
  border-collapse: collapse;
  border-radius: var(--ma-radius-md);
  overflow: hidden;
  font-size: 14px;
  box-shadow: var(--ma-shadow-sm);
  background: var(--ma-grad-surface);
}
.ma-route .ma-prose th,
.ma-route .ma-prose td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid var(--ma-border);
}
.ma-route .ma-prose th {
  font-size: var(--ma-fs-micro);
  font-weight: 500;
  letter-spacing: var(--ma-tracking-micro);
  text-transform: uppercase;
  color: var(--ma-text-muted);
  background: var(--ma-surface-soft);
}
.ma-route .ma-prose tr:last-child td { border-bottom: 0; }

/* ── Slide-over (history drawer) ────────────────────────────── */
.ma-route .ma-drawer {
  position: absolute;
  top: 12px;
  bottom: 12px;
  left: 12px;
  width: var(--ma-side-w);
  background: var(--ma-grad-elevated);
  border-radius: var(--ma-radius-lg);
  box-shadow: var(--ma-shadow-lg);
  transform: translateX(calc(-100% - 24px));
  opacity: 0;
  transition:
    transform var(--ma-motion-lg) var(--ma-ease),
    opacity   var(--ma-motion-lg) var(--ma-ease);
  z-index: 30;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  backdrop-filter: blur(4px);
}
.ma-route .ma-drawer[data-open="true"] {
  transform: translateX(0);
  opacity: 1;
}

/* ── Skeleton ───────────────────────────────────────────────── */
.ma-route .ma-skeleton {
  background: linear-gradient(
    90deg,
    var(--ma-surface-soft) 0%,
    var(--ma-border) 50%,
    var(--ma-surface-soft) 100%
  );
  background-size: 200% 100%;
  animation: ma-shimmer 1.4s infinite linear;
  border-radius: var(--ma-radius-sm);
}
@keyframes ma-shimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ── Entrance: soft fade-up for new tiles / rows ────────────── */
@keyframes ma-fade-up {
  0%   { opacity: 0; transform: translateY(6px); }
  100% { opacity: 1; transform: translateY(0); }
}
.ma-route .ma-fade-up {
  animation: ma-fade-up var(--ma-motion-lg) var(--ma-ease) both;
}

/* ── Sim.ai tile (the right-rail dashboard tile) ────────────── */
.ma-route .ma-tile {
  background: var(--ma-grad-surface);
  border-radius: var(--ma-radius-md);
  box-shadow: var(--ma-shadow-sm);
  padding: 14px 16px;
}
.ma-route .ma-tile__title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: var(--ma-fs-micro);
  font-weight: 500;
  letter-spacing: var(--ma-tracking-micro);
  text-transform: uppercase;
  color: var(--ma-text-muted);
  margin-bottom: 10px;
}
.ma-route .ma-tile__metric {
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.01em;
  font-variant-numeric: tabular-nums;
  color: var(--ma-text);
}

/* Right rail — flush sections with clear visual hierarchy.
   Each section is a full-width block with a hairline bottom border.
   Odd-indexed sections get a very subtle surface tint for zebra depth. */
.ma-route .ma-rail > * {
  padding: 12px 16px;
  border-bottom: 1px solid color-mix(in oklab, var(--ma-divider) 44%, transparent);
}
.ma-route .ma-rail__header {
  padding: 8px 16px 6px;
  border-bottom: 1px solid color-mix(in oklab, var(--ma-divider) 66%, transparent);
  background: color-mix(in oklab, var(--ma-panel-bg) 60%, transparent);
}
.ma-route .ma-rail .ma-tile {
  background: transparent;
  border-radius: 0;
  box-shadow: none;
}
/* Section title row — slightly more visual weight to anchor each section */
.ma-route .ma-rail .ma-tile__title {
  font-size: 10px;
  letter-spacing: 0.1em;
  font-weight: 600;
  margin-bottom: 8px;
  color: var(--ma-text-muted);
}
/* Alternating section background — very subtle so it doesn't compete */
.ma-route .ma-rail > *:nth-child(even) {
  background: color-mix(in oklab, var(--ma-panel-bg-soft) 30%, transparent);
}
.ma-route .ma-rail > :last-child {
  border-bottom: 0;
}
/* Section group label — used for grouping related tiles under a shared heading */
.ma-route .ma-rail__group-label {
  padding: 6px 16px 4px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: color-mix(in oklab, var(--ma-text-muted) 60%, transparent);
  border-bottom: 0;
  background: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/pages/multi-agent/styles/multi-agent-tokens.css"],"names":[],"mappings":"AAAA;;;;;;;;;;EAUE;;AAEF;EACE,iEAAiE;EACjE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,wBAAwB;EACxB,wBAAwB;EACxB,2BAA2B;;EAE3B,iEAAiE;EACjE,yCAAyC;EACzC,mCAAmC;EACnC,0CAA0C;EAC1C,qCAAqC;EACrC,yCAAyC;EACzC,+CAA+C;EAC/C,sCAAsC;EACtC,6CAA6C;;EAE7C,kCAAkC;EAClC,iCAAiC;EACjC,gCAAgC;EAChC,yDAAyD;;EAEzD,iEAAiE;EACjE,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;;EAEpB,iEAAiE;EACjE;;uEAEqE;EACrE,8CAA8C;EAC9C,mDAAmD;EACnD;;sCAEoC;EACpC;;;sCAGoC;EACpC;;;uCAGqC;;EAErC;;mEAEiE;EACjE;;;;GAIC;EACD;;;;GAIC;EACD;;;;GAIC;;EAED,iEAAiE;EACjE,kBAAkB;EAClB,qBAAqB;EACrB,+CAA+C;;EAE/C,iEAAiE;EACjE,mBAAmB,cAAc,yBAAyB;EAC1D,wCAAwC;EACxC,kEAAkE;EAClE,uFAAuF;EACvF,mFAAmF;EACnF,yFAAyF;EACzF,sEAAsE;AACxE;;AAEA,8BAA8B;AAC9B;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,qBAAqB;EACrB;;oBAEkB;AACpB;;AAEA,kEAAkE;AAClE;EACE,gBAAgB;EAChB,0CAA0C;EAC1C;uHACqH;AACvH;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,SAAS;EACT,gBAAgB;EAChB,sFAAsF;AACxF;;AAEA;;;wCAGwC;AACxC;EACE,gBAAgB;AAClB;;AAEA;;EAEE,+BAA+B;EAC/B;uHACqH;AACvH;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE;+HAC6H;AAC/H;;AAEA;EACE,gBAAgB;EAChB,gFAAgF;EAChF,oEAAoE;AACtE;;AAEA;EACE,gFAAgF;AAClF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,gFAAgF;AAClF;;AAEA;;;;EAIE,uFAAuF;AACzF;;AAEA;;;EAGE,qEAAqE;AACvE;;AAEA;;;yBAGyB;AACzB;EACE,aAAa;EACb,wGAAwG;EACxG,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,iFAAiF;EACjF;;+CAE6C;AAC/C;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,0CAA0C;EAC1C;uHACqH;AACvH;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,6BAA6B;EAC7B,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sEAAsE;EACtE,oEAAoE;EACpE,6DAA6D;AAC/D;;AAEA;EACE,wCAAwC;EACxC,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,wEAAwE;EACxE,sEAAsE;EACtE,+DAA+D;AACjE;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,kEAAkE;AAClE;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,wCAAwC;EACxC,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,kEAAkE;AAClE;EACE,kCAAkC;EAClC,kCAAkC;EAClC,+BAA+B;AACjC;AACA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC;wDACsD;AACxD;AACA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA,kEAAkE;AAClE;EACE;;;oDAGkD;AACpD;AACA;EACE,+BAA+B;AACjC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA,kEAAkE;AAClE;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,gCAAgC;EAChC,UAAU;AACZ;AACA,0BAA0B,8BAA8B,EAAE;AAC1D,0BAA0B,gCAAgC,EAAE;AAC5D,0BAA0B,+BAA+B,EAAE;AAC3D;EACE,gCAAgC;EAChC,6CAA6C;AAC/C;AACA;EACE,0BAA0B,eAAe,EAAE;AAC7C;AACA;EACE,WAAW,UAAU,EAAE;EACvB,WAAW,aAAa,EAAE;AAC5B;;AAEA,kEAAkE;AAClE;EACE,8BAA8B;EAC9B;;;+DAG6D;EAC7D,WAAW;EACX,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,4BAA4B;EAC5B,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE;;;eAGa;EACb,8BAA8B;EAC9B,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;AACA,8BAA8B,gBAAgB,EAAE;AAChD;;;EAGE,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;AACA,yBAAyB,eAAe,EAAE,gBAAgB,EAAE;AAC5D,yBAAyB,eAAe,EAAE,iBAAiB,EAAE;AAC7D;EACE,eAAe;EACf,yBAAyB;EACzB,wCAAwC;EACxC,qBAAqB;EACrB,gBAAgB;AAClB;AACA,yBAAyB,SAAS,EAAE;AACpC;yBACyB,kBAAkB,EAAE;AAC7C,8BAA8B,eAAe,EAAE;;AAE/C;6EAC6E;AAC7E;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;AACjB;AACA,2BAA2B,cAAc,EAAE;;AAE3C;;0BAE0B;AAC1B;;EAEE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,SAAS;EACT,gBAAgB;AAClB;AACA;;EAEE,WAAW;AACb;AACA;EACE,cAAc;AAChB;;AAEA,yDAAyD;AACzD;;EAEE,cAAc;EACd,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,wCAAwC;EACxC,yBAAyB;EACzB,2BAA2B;EAC3B,kCAAkC;AACpC;AACA,uCAAuC,gBAAgB,EAAE;;AAEzD,kEAAkE;AAClE;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,mCAAmC;EACnC,kCAAkC;EAClC,+BAA+B;EAC/B,yCAAyC;EACzC,UAAU;EACV;;gDAE8C;EAC9C,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA,kEAAkE;AAClE;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,0CAA0C;EAC1C,kCAAkC;AACpC;AACA;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,kEAAkE;AAClE;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA;EACE,6DAA6D;AAC/D;;AAEA,kEAAkE;AAClE;EACE,kCAAkC;EAClC,kCAAkC;EAClC,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,gBAAgB;EAChB,wCAAwC;EACxC,yBAAyB;EACzB,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;;yEAEyE;AACzE;EACE,kBAAkB;EAClB,gFAAgF;AAClF;AACA;EACE,qBAAqB;EACrB,gFAAgF;EAChF,oEAAoE;AACtE;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;AACA,2EAA2E;AAC3E;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;AACA,uEAAuE;AACvE;EACE,yEAAyE;AAC3E;AACA;EACE,gBAAgB;AAClB;AACA,iFAAiF;AACjF;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iEAAiE;EACjE,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":["/**\n * multi-agent design tokens — Kimi prose × Sim.ai surfaces.\n *\n * Scoped to .ma-route. Strict rules:\n *   - 4 type sizes: hero / h1 / body / micro\n *   - 1 accent (existing primary)\n *   - 4 state colors (ok / warn / err / busy) — actual state only\n *   - 1 ease, 2 durations (150ms hover, 240ms entrance)\n *   - 3 depth tiers: shadow-sm / shadow-md / shadow-lg\n *   - 2 surface gradients (surface / elevated)\n */\n\n.ma-route {\n  /* ── Type ──────────────────────────────────────────────────── */\n  --ma-fs-hero:  28px;\n  --ma-fs-h1:    18px;\n  --ma-fs-body:  15px;\n  --ma-fs-micro: 11px;\n\n  --ma-leading-body:  1.65;\n  --ma-leading-micro: 1.35;\n  --ma-tracking-micro: 0.08em;\n\n  /* ── Color ─────────────────────────────────────────────────── */\n  --ma-bg:           hsl(var(--background));\n  --ma-surface:      hsl(var(--card));\n  --ma-surface-soft: hsl(var(--muted) / 0.4);\n  --ma-border:       hsl(var(--border));\n  --ma-text:         hsl(var(--foreground));\n  --ma-text-muted:   hsl(var(--muted-foreground));\n  --ma-accent:       hsl(var(--primary));\n  --ma-accent-soft:  hsl(var(--primary) / 0.08);\n\n  --ma-state-ok:    hsl(151 55% 41%);\n  --ma-state-warn:  hsl(38 92% 50%);\n  --ma-state-err:   hsl(0 72% 51%);\n  --ma-state-busy:  hsl(var(--accent-glow, var(--primary)));\n\n  /* ── Geometry ──────────────────────────────────────────────── */\n  --ma-radius-sm: 6px;\n  --ma-radius-md: 12px;\n  --ma-radius-lg: 18px;\n\n  /* ── Depth ─────────────────────────────────────────────────── */\n  /* Use --foreground as the shadow base so it adapts: dark in light\n     mode (subtle slate shadow on white) and dark in dark mode (deeper\n     drop on near-black). The hardcoded 220/2% looked grimy in light. */\n  --ma-shadow-rgb: hsl(var(--foreground) / 0.12);\n  --ma-shadow-rgb-soft: hsl(var(--foreground) / 0.06);\n  --ma-shadow-sm:\n    0 1px 2px var(--ma-shadow-rgb-soft),\n    0 0 0 1px hsl(var(--border) / 0.7);\n  --ma-shadow-md:\n    0 4px 6px -1px var(--ma-shadow-rgb-soft),\n    0 2px 4px -2px var(--ma-shadow-rgb-soft),\n    0 0 0 1px hsl(var(--border) / 0.8);\n  --ma-shadow-lg:\n    0 18px 28px -10px var(--ma-shadow-rgb),\n    0 6px 10px -4px var(--ma-shadow-rgb-soft),\n    0 0 0 1px hsl(var(--border) / 0.85);\n\n  /* Surface gradients — use the global card token so they invert. The\n     elevated tint is tied to --primary; in light mode the small primary\n     blend reads as a faint warm card edge instead of muddy gray. */\n  --ma-grad-surface: linear-gradient(\n    180deg,\n    hsl(var(--card)) 0%,\n    color-mix(in oklab, hsl(var(--card)) 92%, hsl(var(--foreground)) 8%) 100%\n  );\n  --ma-grad-elevated: linear-gradient(\n    180deg,\n    color-mix(in oklab, hsl(var(--card)) 96%, hsl(var(--primary)) 4%) 0%,\n    hsl(var(--card)) 100%\n  );\n  --ma-grad-accent: linear-gradient(\n    135deg,\n    hsl(var(--primary) / 0.16) 0%,\n    hsl(var(--primary) / 0.04) 100%\n  );\n\n  /* ── Motion ────────────────────────────────────────────────── */\n  --ma-motion: 150ms;\n  --ma-motion-lg: 240ms;\n  --ma-ease: cubic-bezier(0.25, 0.46, 0.45, 0.94);\n\n  /* ── Layout ────────────────────────────────────────────────── */\n  --ma-rail-w:    0px;             /* no left rail anymore */\n  --ma-side-w:   clamp(280px, 24vw, 320px);\n  --ma-prose-max: min(1120px, calc(100vw - var(--ma-side-w) - 96px));\n  --ma-app-bg: color-mix(in oklab, hsl(var(--background)) 93%, hsl(var(--foreground)) 7%);\n  --ma-panel-bg: color-mix(in oklab, hsl(var(--card)) 94%, hsl(var(--background)) 6%);\n  --ma-panel-bg-soft: color-mix(in oklab, hsl(var(--card)) 86%, hsl(var(--background)) 14%);\n  --ma-divider: color-mix(in oklab, hsl(var(--border)) 58%, transparent);\n}\n\n/* Default type on the route */\n.ma-route {\n  font-size: var(--ma-fs-body);\n  line-height: var(--ma-leading-body);\n  color: var(--ma-text);\n  background:\n    radial-gradient(circle at 48% -10%, hsl(var(--primary) / 0.08), transparent 34%),\n    var(--ma-app-bg);\n}\n\n/* ── Product shell polish ───────────────────────────────────── */\n.ma-route .ma-route-header {\n  min-height: 48px;\n  border-bottom: 1px solid var(--ma-divider);\n  background:\n    linear-gradient(180deg, color-mix(in oklab, var(--ma-panel-bg) 96%, hsl(var(--foreground)) 4%), var(--ma-panel-bg));\n}\n\n.ma-route .ma-ide-shell {\n  flex-direction: column;\n  background: var(--ma-app-bg);\n}\n\n.ma-route .ma-ide-body {\n  margin: 0;\n  border: 0;\n  border-radius: 0;\n  background: color-mix(in oklab, hsl(var(--background)) 96%, hsl(var(--foreground)) 4%);\n}\n\n/* The shared metadata section caps its file list at max-h-64 (256px). In the\n   multi-agent sidebar the list should fill the available column height instead,\n   so the surrounding flex-1 section scrolls. Scoped to the left panel only —\n   the dev-agent default is untouched. */\n.ma-route .ma-left-utility .max-h-64 {\n  max-height: none;\n}\n\n.ma-route .ma-left-utility,\n.ma-route .ma-right-context {\n  border-color: var(--ma-divider);\n  background:\n    linear-gradient(180deg, color-mix(in oklab, var(--ma-panel-bg) 98%, hsl(var(--foreground)) 2%), var(--ma-panel-bg));\n}\n\n.ma-route .ma-left-utility {\n  border-right: 1px solid color-mix(in oklab, var(--ma-divider) 66%, transparent);\n}\n\n.ma-route .ma-right-context {\n  border-left: 1px solid color-mix(in oklab, var(--ma-divider) 66%, transparent);\n}\n\n.ma-route .ma-center-workspace {\n  background:\n    linear-gradient(180deg, color-mix(in oklab, hsl(var(--background)) 99%, hsl(var(--foreground)) 1%), hsl(var(--background)));\n}\n\n.ma-route .ma-panel-toolbar {\n  min-height: 34px;\n  border-bottom: 1px solid color-mix(in oklab, var(--ma-divider) 46%, transparent);\n  background: color-mix(in oklab, var(--ma-panel-bg) 86%, transparent);\n}\n\n.ma-route .ma-panel-section {\n  border-bottom: 1px solid color-mix(in oklab, var(--ma-divider) 44%, transparent);\n}\n\n.ma-route .ma-panel-section:last-child {\n  border-bottom: 0;\n}\n\n.ma-route .ma-right-context__scroll {\n  padding-bottom: 12px;\n  background: var(--ma-panel-bg);\n}\n\n.ma-route .ma-right-context__section {\n  border-bottom: 1px solid color-mix(in oklab, var(--ma-divider) 44%, transparent);\n}\n\n.ma-route .ma-left-utility .border-b,\n.ma-route .ma-right-context .border-b,\n.ma-route .ma-left-utility [class*=\"border-b\"],\n.ma-route .ma-right-context [class*=\"border-b\"] {\n  border-bottom-color: color-mix(in oklab, var(--ma-divider) 42%, transparent) !important;\n}\n\n.ma-route .ma-left-utility input,\n.ma-route .ma-left-utility button,\n.ma-route .ma-left-utility [role=\"combobox\"] {\n  border-color: color-mix(in oklab, var(--ma-divider) 58%, transparent);\n}\n\n/* Floating composer — no dock bar (no border, no fill). The rounded\n   .ma-composer-shell floats over the chat; a soft bottom fade keeps scrolling\n   text from butting hard against it. The dock catches no pointer events except\n   on the shell itself. */\n.ma-route .ma-composer-dock {\n  border-top: 0;\n  background: linear-gradient(180deg, transparent, color-mix(in oklab, var(--ma-app-bg) 70%, transparent));\n  pointer-events: none;\n}\n.ma-route .ma-composer-dock > * {\n  pointer-events: auto;\n}\n\n.ma-route .ma-composer-shell {\n  background: color-mix(in oklab, hsl(var(--background)) 88%, hsl(var(--card)) 12%);\n  box-shadow:\n    0 12px 28px -24px hsl(var(--foreground) / 0.35),\n    inset 0 1px 0 hsl(var(--foreground) / 0.03);\n}\n\n/* ── Always visible run strip ───────────────────────────────── */\n.ma-route .ma-run-strip {\n  display: flex;\n  min-height: 48px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 8px 18px;\n  border-bottom: 1px solid var(--ma-divider);\n  background:\n    linear-gradient(180deg, color-mix(in oklab, var(--ma-panel-bg) 94%, hsl(var(--foreground)) 6%), var(--ma-panel-bg));\n}\n\n.ma-route .ma-run-strip__stages {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 8px;\n}\n\n.ma-route .ma-run-stage {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  border-radius: 999px;\n  border: 1px solid transparent;\n  padding: 5px 10px;\n  color: var(--ma-text-muted);\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.ma-route .ma-run-stage--done {\n  border-color: color-mix(in oklab, var(--ma-state-ok) 32%, transparent);\n  background: color-mix(in oklab, var(--ma-state-ok) 12%, transparent);\n  color: color-mix(in oklab, var(--ma-state-ok) 78%, white 22%);\n}\n\n.ma-route .ma-run-stage--active {\n  border-color: hsl(var(--primary) / 0.45);\n  background: hsl(var(--primary) / 0.11);\n  color: hsl(var(--primary));\n}\n\n.ma-route .ma-run-stage--warn {\n  border-color: color-mix(in oklab, var(--ma-state-warn) 38%, transparent);\n  background: color-mix(in oklab, var(--ma-state-warn) 14%, transparent);\n  color: color-mix(in oklab, var(--ma-state-warn) 78%, white 22%);\n}\n\n.ma-route .ma-run-strip__summary {\n  min-width: 180px;\n  max-width: min(42vw, 560px);\n  overflow: hidden;\n  text-align: right;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--ma-text);\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.ma-route .ma-run-strip__latest {\n  color: var(--ma-text-muted);\n  font-weight: 500;\n}\n\n@media (max-width: 1100px) {\n  .ma-route .ma-run-strip {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .ma-route .ma-run-strip__stages {\n    flex-wrap: wrap;\n  }\n\n  .ma-route .ma-run-strip__summary {\n    max-width: 100%;\n    text-align: left;\n  }\n}\n\n/* ── Type utilities ─────────────────────────────────────────── */\n.ma-route .ma-hero {\n  font-size: var(--ma-fs-hero);\n  font-weight: 600;\n  letter-spacing: -0.018em;\n  line-height: 1.2;\n}\n.ma-route .ma-micro {\n  font-size: var(--ma-fs-micro);\n  font-weight: 500;\n  letter-spacing: var(--ma-tracking-micro);\n  line-height: var(--ma-leading-micro);\n  text-transform: uppercase;\n  color: var(--ma-text-muted);\n}\n\n/* ── Surface (gradient + shadow card) ───────────────────────── */\n.ma-route .ma-surface {\n  background: var(--ma-grad-surface);\n  border-radius: var(--ma-radius-md);\n  box-shadow: var(--ma-shadow-sm);\n}\n.ma-route .ma-surface--soft {\n  background: var(--ma-surface-soft);\n  box-shadow: none;\n}\n.ma-route .ma-surface--accent {\n  background: var(--ma-grad-accent);\n  box-shadow: var(--ma-shadow-sm),\n              inset 0 0 0 1px hsl(var(--primary) / 0.25);\n}\n.ma-route .ma-surface--elevated {\n  background: var(--ma-grad-elevated);\n  box-shadow: var(--ma-shadow-md);\n}\n\n/* ── Interactive (lift + ring) ──────────────────────────────── */\n.ma-route .ma-interactive {\n  transition:\n    box-shadow      var(--ma-motion) var(--ma-ease),\n    transform       var(--ma-motion) var(--ma-ease),\n    background-color var(--ma-motion) var(--ma-ease);\n}\n.ma-route .ma-interactive:hover {\n  box-shadow: var(--ma-shadow-md);\n}\n.ma-route .ma-interactive--card:hover {\n  transform: translateY(-1px);\n}\n.ma-route .ma-interactive:focus-visible {\n  outline: 2px solid var(--ma-accent);\n  outline-offset: 2px;\n}\n\n/* ── Status dot ─────────────────────────────────────────────── */\n.ma-route .ma-dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n  background: var(--ma-text-muted);\n  flex: none;\n}\n.ma-route .ma-dot--ok   { background: var(--ma-state-ok); }\n.ma-route .ma-dot--warn { background: var(--ma-state-warn); }\n.ma-route .ma-dot--err  { background: var(--ma-state-err); }\n.ma-route .ma-dot--busy {\n  background: var(--ma-state-busy);\n  animation: ma-pulse 1.4s infinite ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .ma-route .ma-dot--busy { animation: none; }\n}\n@keyframes ma-pulse {\n  0%, 100% { opacity: 1; }\n  50%      { opacity: 0.35; }\n}\n\n/* ── Prose (Kimi answer area) ───────────────────────────────── */\n.ma-route .ma-prose {\n  max-width: var(--ma-prose-max);\n  /* min-width:0 lets this block shrink below its content width inside a\n     flex column — without it, flex items can report a wider offsetWidth to\n     Monaco than the visual layout, causing the diff editor to overshoot\n     into the sidebar. width:100% fills the available column. */\n  width: 100%;\n  min-width: 0;\n  margin: 0 auto;\n  padding: 32px 24px 56px;\n  font-size: var(--ma-fs-body);\n  line-height: var(--ma-leading-body);\n  color: var(--ma-text);\n}\n\n.ma-route .ma-prose--active-chat {\n  /* Fill the full width of the chat column (the centre workspace sets\n     --ma-prose-max to 100% in the default layout; narrow/wide variants still\n     cap it). Was hard-capped at min(1320px, …) which left dead space on wide\n     screens. */\n  max-width: var(--ma-prose-max);\n  padding-left: clamp(24px, 3vw, 48px);\n  padding-right: clamp(24px, 3vw, 48px);\n}\n\n.ma-route .ma-prose--active-chat .ma-hero {\n  font-size: clamp(26px, 3vw, 40px);\n  line-height: 1.16;\n}\n.ma-route .ma-prose > * + * { margin-top: 18px; }\n.ma-route .ma-prose h1,\n.ma-route .ma-prose h2,\n.ma-route .ma-prose h3 {\n  margin-top: 36px;\n  font-weight: 600;\n  letter-spacing: -0.012em;\n  color: var(--ma-text);\n}\n.ma-route .ma-prose h1 { font-size: 22px; line-height: 1.3; }\n.ma-route .ma-prose h2 { font-size: 19px; line-height: 1.35; }\n.ma-route .ma-prose h3 {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: var(--ma-tracking-micro);\n  color: var(--ma-text);\n  font-weight: 600;\n}\n.ma-route .ma-prose p  { margin: 0; }\n.ma-route .ma-prose ul,\n.ma-route .ma-prose ol { padding-left: 22px; }\n.ma-route .ma-prose li + li { margin-top: 6px; }\n\n/* Real links across the chat — blue + underlined so they read as clickable\n   (they used to inherit the muted prose color and looked like plain text). */\n.ma-route .ma-link {\n  color: #4f9dff;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n  cursor: pointer;\n}\n.ma-route .ma-link:hover { color: #74b2ff; }\n\n/* A list that is only citation chips — e.g. the model's \"Evidence Artifacts\"\n   section — flows inline like the Sources strip: wrapped pills, no bullets,\n   no vertical stacking. */\n.ma-route .ma-prose ul:has(.ma-citation-chip),\n.ma-route .ma-prose ol:has(.ma-citation-chip) {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  padding-left: 0;\n  margin-top: 10px;\n  list-style: none;\n}\n.ma-route .ma-prose ul:has(.ma-citation-chip) > li,\n.ma-route .ma-prose ol:has(.ma-citation-chip) > li {\n  margin: 0;\n  list-style: none;\n}\n.ma-route .ma-prose ul:has(.ma-citation-chip) > li::marker,\n.ma-route .ma-prose ol:has(.ma-citation-chip) > li::marker {\n  content: \"\";\n}\n.ma-route .ma-prose ul:has(.ma-citation-chip) .ma-citation-chip {\n  margin-left: 0;\n}\n\n/* Expanded artifact blocks break out of list-item flow */\n.ma-route .ma-prose .ma-artifact-block,\n.ma-route .ma-artifact-block {\n  display: block;\n  width: 100%;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  list-style: none;\n}\n.ma-route .ma-prose li:has(.ma-artifact-block) {\n  list-style: none;\n  margin-left: -22px;\n  padding-left: 0;\n}\n\n.ma-route .ma-prose code {\n  font-size: 13px;\n  padding: 2px 6px;\n  border-radius: 5px;\n  background: var(--ma-surface-soft);\n  border: 1px solid hsl(var(--border) / 0.4);\n}\n.ma-route .ma-prose table {\n  width: 100%;\n  border-collapse: collapse;\n  border-radius: var(--ma-radius-md);\n  overflow: hidden;\n  font-size: 14px;\n  box-shadow: var(--ma-shadow-sm);\n  background: var(--ma-grad-surface);\n}\n.ma-route .ma-prose th,\n.ma-route .ma-prose td {\n  padding: 10px 12px;\n  text-align: left;\n  border-bottom: 1px solid var(--ma-border);\n}\n.ma-route .ma-prose th {\n  font-size: var(--ma-fs-micro);\n  font-weight: 500;\n  letter-spacing: var(--ma-tracking-micro);\n  text-transform: uppercase;\n  color: var(--ma-text-muted);\n  background: var(--ma-surface-soft);\n}\n.ma-route .ma-prose tr:last-child td { border-bottom: 0; }\n\n/* ── Slide-over (history drawer) ────────────────────────────── */\n.ma-route .ma-drawer {\n  position: absolute;\n  top: 12px;\n  bottom: 12px;\n  left: 12px;\n  width: var(--ma-side-w);\n  background: var(--ma-grad-elevated);\n  border-radius: var(--ma-radius-lg);\n  box-shadow: var(--ma-shadow-lg);\n  transform: translateX(calc(-100% - 24px));\n  opacity: 0;\n  transition:\n    transform var(--ma-motion-lg) var(--ma-ease),\n    opacity   var(--ma-motion-lg) var(--ma-ease);\n  z-index: 30;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  backdrop-filter: blur(4px);\n}\n.ma-route .ma-drawer[data-open=\"true\"] {\n  transform: translateX(0);\n  opacity: 1;\n}\n\n/* ── Skeleton ───────────────────────────────────────────────── */\n.ma-route .ma-skeleton {\n  background: linear-gradient(\n    90deg,\n    var(--ma-surface-soft) 0%,\n    var(--ma-border) 50%,\n    var(--ma-surface-soft) 100%\n  );\n  background-size: 200% 100%;\n  animation: ma-shimmer 1.4s infinite linear;\n  border-radius: var(--ma-radius-sm);\n}\n@keyframes ma-shimmer {\n  0%   { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n/* ── Entrance: soft fade-up for new tiles / rows ────────────── */\n@keyframes ma-fade-up {\n  0%   { opacity: 0; transform: translateY(6px); }\n  100% { opacity: 1; transform: translateY(0); }\n}\n.ma-route .ma-fade-up {\n  animation: ma-fade-up var(--ma-motion-lg) var(--ma-ease) both;\n}\n\n/* ── Sim.ai tile (the right-rail dashboard tile) ────────────── */\n.ma-route .ma-tile {\n  background: var(--ma-grad-surface);\n  border-radius: var(--ma-radius-md);\n  box-shadow: var(--ma-shadow-sm);\n  padding: 14px 16px;\n}\n.ma-route .ma-tile__title {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: var(--ma-fs-micro);\n  font-weight: 500;\n  letter-spacing: var(--ma-tracking-micro);\n  text-transform: uppercase;\n  color: var(--ma-text-muted);\n  margin-bottom: 10px;\n}\n.ma-route .ma-tile__metric {\n  font-size: 20px;\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  font-variant-numeric: tabular-nums;\n  color: var(--ma-text);\n}\n\n/* Right rail — flush sections with clear visual hierarchy.\n   Each section is a full-width block with a hairline bottom border.\n   Odd-indexed sections get a very subtle surface tint for zebra depth. */\n.ma-route .ma-rail > * {\n  padding: 12px 16px;\n  border-bottom: 1px solid color-mix(in oklab, var(--ma-divider) 44%, transparent);\n}\n.ma-route .ma-rail__header {\n  padding: 8px 16px 6px;\n  border-bottom: 1px solid color-mix(in oklab, var(--ma-divider) 66%, transparent);\n  background: color-mix(in oklab, var(--ma-panel-bg) 60%, transparent);\n}\n.ma-route .ma-rail .ma-tile {\n  background: transparent;\n  border-radius: 0;\n  box-shadow: none;\n}\n/* Section title row — slightly more visual weight to anchor each section */\n.ma-route .ma-rail .ma-tile__title {\n  font-size: 10px;\n  letter-spacing: 0.1em;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: var(--ma-text-muted);\n}\n/* Alternating section background — very subtle so it doesn't compete */\n.ma-route .ma-rail > *:nth-child(even) {\n  background: color-mix(in oklab, var(--ma-panel-bg-soft) 30%, transparent);\n}\n.ma-route .ma-rail > :last-child {\n  border-bottom: 0;\n}\n/* Section group label — used for grouping related tiles under a shared heading */\n.ma-route .ma-rail__group-label {\n  padding: 6px 16px 4px;\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: color-mix(in oklab, var(--ma-text-muted) 60%, transparent);\n  border-bottom: 0;\n  background: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
